import React from 'react';
import Hero from "./components/prog-offered/Hero";
import Main from "./components/prog-offered/Main";

const ProgOffered = () => {
  return (
    <div>
        <Hero />
        <Main />
    </div>
  )
}

export default ProgOffered;